import { Heading, TextField } from "@elaniintc/goes-design-system";
import { useCondition } from "./useCondition";
import { useMemo } from "react";

export const IfNameInputs = () => {
  const {
    trueLabel,
    falseLabel,
    setTrueLabel,
    setFalseLabel,
    trueLabelInvalid,
    falseLabelInvalid,
  } = useCondition();

  const validationState = useMemo(() => {
    const showEqualError =
      trueLabel.trim().toLowerCase() === falseLabel.trim().toLowerCase() &&
      trueLabel.trim() !== "" &&
      falseLabel.trim() !== "";

    return {
      showEqualError,
      trueLabelTooLong: trueLabel.length > 97,
      falseLabelTooLong: falseLabel.length > 97,
      trueLabelEmpty: trueLabel.trim() === "" && trueLabel !== "",
      falseLabelEmpty: falseLabel.trim() === "" && falseLabel !== "",
    };
  }, [trueLabel, falseLabel]);

  return (
    <div className="flex flex-col gap-3 px-6 pt-3 pb-6 border-b border-neutral-quiet">
      <Heading variant="h6">Configurar Salidas</Heading>

      <TextField
        id="trueLabel"
        name="trueLabel"
        label='Nombre de la salida "Verdadero"'
        placeholder="Escribe el nombre de la salida"
        required
        value={trueLabel}
        onChange={(e) => {
          setTrueLabel(e.target.value);
        }}
        error={
          validationState.trueLabelEmpty
            ? "El nombre no puede estar vacío"
            : validationState.trueLabelTooLong
              ? "Máximo 97 caracteres"
              : trueLabelInvalid
                ? "No se permiten caracteres especiales"
                : undefined
        }
      />

      <TextField
        id="falseLabel"
        name="falseLabel"
        label='Nombre de la salida "Falso"'
        placeholder="Escribe el nombre de la salida"
        required
        value={falseLabel}
        onChange={(e) => {
          setFalseLabel(e.target.value);
        }}
        error={
          validationState.falseLabelEmpty
            ? "El nombre no puede estar vacío"
            : validationState.falseLabelTooLong
              ? "Máximo 97 caracteres"
              : falseLabelInvalid
                ? "No se permiten caracteres especiales"
                : validationState.showEqualError
                  ? "Los nombres deben ser diferentes"
                  : undefined
        }
      />
    </div>
  );
};
